import Immutable from 'immutable';

export default ({userRole, $$data}) => {
  const $$subscriptions = userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined
  ? $$data.get('myfutureevents').sortBy(e => e.get('eventDate')).map(e => e.get('id'))
  : Immutable.Map();
  return $$subscriptions
}



// WEBPACK FOOTER //
// ./src/helpers/getMySubscriptions.jsx